import invariant from 'invariant'
import {compact, filter, isEmpty, map} from 'lodash'
import {IMPLEMENTATION_INSURANCE, INSURANCE_IMPLEMENTATIONS} from '../../../constants/implementations'


// eslint-disable-next-line no-process-env
const insuranceImplementations = new Set(process.env.GATSBY_IMPLEMENTATIONS?.split(';'))
invariant(!isEmpty(insuranceImplementations), 'Missing gatsby implementations')

export const implementations = new Set(compact(map(INSURANCE_IMPLEMENTATIONS, (availableImplementations, insurance) => {
  const activeImplementations = filter(availableImplementations, (impl) => insuranceImplementations.has(impl))
  invariant(activeImplementations.length <= 1,
    `Multiple gatsby implementations [${activeImplementations}] for insurance: ${insurance}`)
  if (!isEmpty(activeImplementations)) return activeImplementations[0]
})))

export const insurances = new Set(
  map([...implementations], (implementation) => IMPLEMENTATION_INSURANCE[implementation]))
